// Hook for accessing CSR context
import { useContext } from 'react';
import { CSRContext } from '../contexts/CSRContext';

export function useCSRContext() {
  return useContext(CSRContext);
}